<li class="dropdown custom-dropdown" dropdown [attr.data-automation-id]="automationId">
    <div dropdownToggle role="button" class="custom-dropdown-option header-option"
        [attr.data-automation-id]="automationId + '-selected-option'" [ngClass]="[disabled ? 'disabled' : '']"
        *ngIf="selectedItem">
        <div class="custom-dropdown-option-icon" [ngClass]="[selectedItem.iconSecond ? 'multiple-icons' : '']">
            <i *ngIf="selectedItem.icon"
                [ngClass]="['fa', selectedItem.icon, selectedItem.iconColor ? selectedItem.iconColor : '', disabled && selectedItem.iconColorDisabled ? selectedItem.iconColorDisabled : '']"></i>
            <i *ngIf="selectedItem.iconSecond" style="font-size: 10px;"
                [ngClass]="['second-icon fa', selectedItem.iconSecond, selectedItem.iconSecondColor ? selectedItem.iconSecondColor : '', disabled && selectedItem.iconColorDisabled ? selectedItem.iconColorDisabled : '']"></i>
            <img *ngIf="selectedItem.iconUrl"
                [src]="selectedItem.iconUrlSelected ? ('assets/images/' + selectedItem.iconUrlSelected) : ('assets/images/' + selectedItem.iconUrl)">
        </div>
        <span [style.marginLeft.px]="selectedItem.icon || selectedItem.iconUrl ? 0 : 10">{{selectedItem.name ||
            selectedItem.smfMessageBody}}</span>
        <i class="fa fa-caret-down color-grey-10"></i>
    </div>
    <ul *dropdownMenu class="dropdown-menu">
        <li *ngFor="let item of items; index as i" (click)="selectItem(item)" class="custom-dropdown-option"
            [style.height.px]="optionHeight" [style.lineHeight.px]="optionHeight"
            [ngClass]="[item == selectedItem ? 'selected-option' : '']"
            [attr.data-automation-id]="automationId + '-option-' + i">
            <div class="custom-dropdown-option-icon" [style.height.px]="optionHeight" [style.width.px]="optionHeight"
                [style.marginLeft.px]="item.level * 15">
                <i *ngIf="item.icon" [ngClass]="['fa', item.icon, item.iconColor ? item.iconColor : '']"></i>
                <i *ngIf="item.iconSecond" style="font-size: 10px;"
                    [ngClass]="['second-icon fa', item.iconSecond, item.iconSecondColor ? item.iconSecondColor : '']"></i>
                <img *ngIf="item.iconUrl" [src]="'assets/images/' + item.iconUrl">
            </div>
            <span [style.marginLeft.px]="item.icon || selectedItem.iconUrl ? 0 : 10">{{item.name}}</span>
        </li>
    </ul>
</li>